<app-ace-select
  bindLabel="name"
  bindValue="priority_id"
  [appendTo]="appendTo"
  [formControl]="formControl"
  [hideSelected]="false"
  [isReadOnly]="isReadOnly"
  [items]="priorities"
  [loading]="loading"
  [clearable]="clearable"
  [placeholder]="placeholder"
  [multiSelect]="multiSelect"
  [closeOnSelect]="!multiSelect"
  [maxSelectedLabels]="maxSelectedLabels"
  [maxSelectedShowItemName]="maxSelectedShowItemName"
  [truncateLabels]="truncateLabels"
  [maxSelectedItemName]="maxSelectedItemName"
  (touched)="onTouched()"
  (openEvent)="onOpen()"
  (closeEvent)="onClose()"/>
